import {useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns} from '@s-ui/react-atom-button'
import {useSuiContext} from '@s-ui/react-context'
import ListFilters, {listFiltersDirections} from '@adv-mt/mt-list-filters'
import SearchFilters, {searchFiltersButtonDesigns} from '@adv-mt/mt-search-filters'

import {NO_OP, SEARCH_TOPBAR_PLACES} from './config.js'

const SearchTopbar = ({
  aggregations,
  filtersConfig,
  filtersProps = {},
  hasFiltersApplied,
  isLoading = false,
  listingSectionId,
  onCloseFilter = NO_OP,
  onFilter = NO_OP,
  onOpenFilter = NO_OP,
  onRemoveFilters = NO_OP,
  overlayContentRef,
  pageName,
  place,
  search,
  showSearchSave = true,
  totalResults
}) => {
  const {i18n} = useSuiContext()

  const handleCloseFilter = () => onCloseFilter()
  const handleFilter = ({lastFilter, search}) => onFilter({lastFilter, search})
  const handleOpenFilter = () => onOpenFilter()
  const handleRemoveFilters = () => onRemoveFilters()

  // SearchFilters lazy-loads its children, so it is kept out of SSR. It mounts after hydration:
  // a `typeof window` check would render it during the hydration pass too, and the markup
  // mismatch (React #418) makes React throw away the server HTML of the whole page.
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => setIsMounted(true), [])

  return (
    <div className="mt-SearchTopbar">
      <div className="mt-SearchTopbar-filtersGroupBasic">
        <div className="mt-SearchTopbar-filtersBtn">
          {isMounted && (
            <SearchFilters
              aggregations={aggregations}
              customButtonText={i18n.t('COMMON.MORE_FILTERS')}
              design={searchFiltersButtonDesigns.PRIMARY}
              filtersProps={filtersProps}
              listingSectionId={listingSectionId}
              pageName={pageName}
              place={place}
              search={search}
              showSearchSave={showSearchSave}
              totalResults={totalResults}
            />
          )}
        </div>
        <div className="mt-SearchTopbar-filtersList">
          <ListFilters
            aggregations={aggregations}
            config={filtersConfig}
            direction={listFiltersDirections.row}
            filtersProps={filtersProps}
            isLoading={isLoading}
            isSearchTopbar
            listingSectionId={listingSectionId}
            onCloseFilter={handleCloseFilter}
            onFilter={handleFilter}
            onOpenFilter={handleOpenFilter}
            overlayContentRef={overlayContentRef}
            pageName={pageName}
            search={search}
            totalResults={totalResults}
          />
          <div className="mt-SearchTopbar-filtersClear">
            <AtomButton design={atomButtonDesigns.LINK} disabled={!hasFiltersApplied} onClick={handleRemoveFilters}>
              {i18n.t('COMMON.DELETE_FILTERS')}
            </AtomButton>
          </div>
        </div>
      </div>
    </div>
  )
}

SearchTopbar.displayName = 'SearchTopbar'
SearchTopbar.propTypes = {
  aggregations: PropTypes.array,
  filtersProps: PropTypes.object,
  filtersConfig: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.node,
      name: PropTypes.string
    })
  ),
  hasFiltersApplied: PropTypes.bool,
  isLoading: PropTypes.bool,
  listingSectionId: PropTypes.string,
  onCloseFilter: PropTypes.func,
  onFilter: PropTypes.func,
  onOpenFilter: PropTypes.func,
  onRemoveFilters: PropTypes.func,
  overlayContentRef: PropTypes.object,
  pageName: PropTypes.string,
  place: PropTypes.string,
  search: PropTypes.object,
  showSearchSave: PropTypes.bool,
  totalResults: PropTypes.number
}

export {SEARCH_TOPBAR_PLACES as searchTopbarPlaces}

export default SearchTopbar
